/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityCopyingRequestBody
 */
export interface EntityCopyingRequestBody {
    /**
     * 
     * @type {number}
     * @memberof EntityCopyingRequestBody
     */
    sourceSceneId: number;
    /**
     * 
     * @type {number}
     * @memberof EntityCopyingRequestBody
     */
    destinationSceneId: number;
    /**
     * 
     * @type {string}
     * @memberof EntityCopyingRequestBody
     */
    startingFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCopyingRequestBody
     */
    endingAt?: string;
}

export function EntityCopyingRequestBodyFromJSON(json: any): EntityCopyingRequestBody {
    return EntityCopyingRequestBodyFromJSONTyped(json, false);
}

export function EntityCopyingRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityCopyingRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceSceneId': json['source_scene_id'],
        'destinationSceneId': json['destination_scene_id'],
        'startingFrom': !exists(json, 'starting_from') ? undefined : json['starting_from'],
        'endingAt': !exists(json, 'ending_at') ? undefined : json['ending_at'],
    };
}

export function EntityCopyingRequestBodyToJSON(value?: EntityCopyingRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_scene_id': value.sourceSceneId,
        'destination_scene_id': value.destinationSceneId,
        'starting_from': value.startingFrom,
        'ending_at': value.endingAt,
    };
}

